import { spawn } from 'redux-saga/effects';
import createBulkActionSagas from './bulkActionSaga';
import createSingleActionSagas from './singleActionSaga';
import createUsersSagas from './userSaga';
import createPurgedUserSaga from './purgedUserSaga';
import createSaveCredentialsSaga from './loginSaga';
import createFeaturesSagas from './featuresSaga';
import createAdminSaga from './adminSaga';
import createLogoutSaga from './logoutSaga';
import createEventsSagas from './eventsSaga';
import apiFactory from '../../services/api';

export default function* sagas(history) {
  const api = apiFactory.create();
  const {
    watchFetchUser,
    watchFetchUsers,
    watchFinishBulkActionWorkflow,
    watchFetchAuditTrail,
    watchSaveAuditTrailComment,
    watchfetchEventHistory,
    watchFetchLoyaltyUser,
  } = createUsersSagas(api, history);

  const {
    watchFetchPurgedUser,
    watchFetchPurgedUsers,
  } = createPurgedUserSaga(api, history);

  const {
    watchFetchAdmins,
    watchPerformAdminAction,
    watchFinishAdminActionWorkflow,
  } = createAdminSaga(api, history);

  const {
    watchBulkActionSubmission,
  } = createBulkActionSagas(api);

  const {
    watchSingleActionSubmission,
  } = createSingleActionSagas(api);

  const {
    watchSaveCredentials,
    watchFailures,
  } = createSaveCredentialsSaga();

  const {
    watchLogout,
  } = createLogoutSaga(api);

  const {
    watchFeaturesSubmissions,
    watchFetchFeaturesSettings,
    watchPerformFeaturesActionSucccess,
    watchFetchFeaturesAuditTrail,
    watchFeaturesSaveAuditTrailComment,
    watchFetchSpinToWinSettings,
  } = createFeaturesSagas(api, history);

  const {
    watchFetchEvents,
    watchCreateEvent,
    watchUpdateEvent,
    watchMarkEventForDeletion,
    watchFetchGamesForEvents,
    watchFetchSingleEvent,
    watchfetchEventAuditLogs,
  } = createEventsSagas(api);

  yield spawn(watchSaveCredentials);
  yield spawn(watchFailures);
  yield spawn(watchFetchUser);
  yield spawn(watchFetchUsers);
  yield spawn(watchFetchPurgedUser);
  yield spawn(watchFetchPurgedUsers);
  yield spawn(watchFinishBulkActionWorkflow);
  yield spawn(watchSingleActionSubmission);
  yield spawn(watchBulkActionSubmission);
  yield spawn(watchFetchAuditTrail);
  yield spawn(watchSaveAuditTrailComment);
  yield spawn(watchFeaturesSubmissions);
  yield spawn(watchPerformFeaturesActionSucccess);
  yield spawn(watchFetchFeaturesSettings);
  yield spawn(watchFetchSpinToWinSettings);
  yield spawn(watchFetchFeaturesAuditTrail);
  yield spawn(watchFeaturesSaveAuditTrailComment);
  yield spawn(watchFetchAdmins);
  yield spawn(watchPerformAdminAction);
  yield spawn(watchFinishAdminActionWorkflow);
  yield spawn(watchLogout);
  yield spawn(watchFetchEvents);
  yield spawn(watchCreateEvent);
  yield spawn(watchUpdateEvent);
  yield spawn(watchMarkEventForDeletion);
  yield spawn(watchFetchGamesForEvents);
  yield spawn(watchFetchSingleEvent);
  yield spawn(watchfetchEventAuditLogs);
  yield spawn(watchfetchEventHistory);
  yield spawn(watchFetchLoyaltyUser);
}



// WEBPACK FOOTER //
// ./src/js/redux/sagas/index.js